import type { ReactNode } from 'react'
import type { TelemetryPort } from '@/domain/telemetry/TelemetryPort'
import { TelemetryContext } from './telemetryContext'

export function TelemetryProvider({
  telemetry,
  children,
}: {
  telemetry: TelemetryPort
  children: ReactNode
}) {
  return (
    <TelemetryContext.Provider value={telemetry}>
      {children}
    </TelemetryContext.Provider>
  )
}
